export enum CmsResourceContentType {
  DragBoard = 'CmsDragBoard',
  Video = 'CmsVideo',
  OrderingGame = 'CmsOrderingGame',
  CoGame = 'CmsCOGame',
  Pdf = 'CmsPdf',
  Article = 'CmsArticle'
}
